<template>
    <v-form v-model="valid">
      
        <div class="title_cover">
            <h3>{{data.tebak_skor.question}}</h3>
        </div>

        <div class="list_tebak mt-5 mb-5">
            <v-row no-gutters>
                <v-col cols="6" v-for="t in form" :key="t.id" >
                    <div class="item_jawab">
                        <div class="titel_logo mb-1">
                            <h2>{{t.item}}</h2>
                        </div>
                        <div class="images_logo mb-3">

                            <img :src="t.other_image.real || t.media" style="max-width: 100%;"/>

                            <!--<v-img contain max-width="100%" :src="t.other_image.real || t.media" :lazy-src="t.thumbnail || t.media">
                                <template v-slot:placeholder>
                                <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                    >
                                    <v-progress-circular
                                        indeterminate
                                        color="grey lighten-5"
                                    ></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>-->
                            
                        </div>
                        <div class="row-input-jawaban mb-3">

                            <v-text-field 
                            type="text" v-model="answer[t.id]"  placeholder="0" solo class="input-skor" maxlength="2" autocomplete="off"
                            :rules="[v => (!isNaN(parseFloat(v)) && v >= 0 && v <= 99) || 'Number has to be between 0 and 99']"/>

                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
        <div class="text-center button_motif mt-4 mb-4">
            <v-btn @click="next" large rounded :loading="isLoading" color="primary" dark :disabled="!( valid && (form.length == Object.keys(this.answer).length)) || isLoading "> Lanjut </v-btn>
        </div>

    </v-form>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "TebakSkor",
  props:['data'],
  computed: mapState(['isLoading']),
  data() {
    return {
      form: this.data.tebak_skor.choose,
      valid: false,
      loading: false,
      answer: this.$session.get('temp_answers') || this.$store.state.data.post.answer
    }
  },
  watch: {
    answer: {
      immediate: true,
      deep: true,
      handler(val) 
      {
        this.$store.commit('set_isvalid_answer', ( this.valid && (this.form.length == Object.keys(val).length) ));
        
        this.$store.commit('set_post_answer', val);

        this.$session.set('temp_answers',val)
      }
    }
  },
  methods:{
      next()
      {
          this.$store.state.data.post.is_finished = 1
          
          this.$store.dispatch('api_post_ic_tebak_skor', {
              score: Object.values(this.$store.state.data.post.answer).join("-"),
              callback: res => {
                  console.log(res)
              }
          });

          //submit
          this.$parent.submit();
      }
  },
  mounted() {
      var answer = this.data.tebak_skor.answered??null
      if(answer==='1')  this.$router.push({name:'result'})
  },
}
</script>